import { render, staticRenderFns } from "./copy-pjp-prev-month.vue?vue&type=template&id=6107c986"
import script from "./copy-pjp-prev-month.vue?vue&type=script&lang=js"
export * from "./copy-pjp-prev-month.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports